import {
  FacebookIcon,
  InstagramIcon,
  PinterestIcon,
  RedditIcon,
  SpotifyIcon,
  TikTokIcon,
  YouTubeIcon,
} from "@/components/SocialIcons";
import {
  BookOpenIcon,
  EnvelopeIcon,
  LinkIcon,
} from "@heroicons/react/24/outline";
import clsx from "clsx";

// Make an object where the key is the network name and the value is the icon. The key is lowercase
// because the network name is lowercase in the CMS.
const networks = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  pinterest: PinterestIcon,
  reddit: RedditIcon,
  spotify: SpotifyIcon,
  tiktok: TikTokIcon,
  youtube: YouTubeIcon,
};

const CustomLinks = ({ links, layout = "vertical", withLabels = true }) => {
  return (
    <div
      className={clsx("CustomLinks", "flex", {
        "flex-col space-y-2 lg:space-y-3": layout === "vertical",
        "flex-row space-x-2 lg:space-x-3": layout === "horizontal",
      })}
    >
      {links.map((link) => {
        let Icon = null;

        // If we have a network icon, use it.
        if (link.typeHandle === "socialLink" && !!link.network) {
          Icon = networks[link.network];
        }

        // If the type is a link, use the link icon.
        if (link.typeHandle === "link") {
          Icon = LinkIcon;
        }

        // If the type is a newsletter, use the envelope icon.
        if (link.typeHandle === "newsletter") {
          Icon = EnvelopeIcon;
        }

        // If the type is a book, use the book icon.
        if (link.typeHandle === "book") {
          Icon = BookOpenIcon;
        }

        return (
          <a
            key={link.id}
            href={link.linkUrl}
            className={clsx(
              "CustomLinks__link",
              "group flex items-center space-x-3 font-body text-sm md:text-base"
            )}
            target="_blank"
            rel="noreferrer"
            aria-label={link.networkUsername || link.label}
          >
            <div
              className={clsx(
                "w-component-sm md:w-component h-component-sm md:h-component flex items-center justify-center rounded-full bg-zinc-100 transition ease-out  group-hover:bg-zinc-900 group-hover:text-white"
              )}
            >
              <div className={clsx("h-4 w-4 [&_svg]:block")}>
                {!!Icon && (
                  <Icon className={clsx("stroke-[2] transition ease-out")} />
                )}
              </div>
            </div>
            {withLabels && <div>{link.networkUsername}</div>}
          </a>
        );
      })}
    </div>
  );
};

export default CustomLinks;
